import React from 'react'
import _, { isEmpty, map } from 'lodash'
import {
  ContentSectionBlock,
  Card,
  Table,
  ContentSection
} from 'camino-react'

import ImpactConcerns from 'Components/Tickets/ImpactConcerns/ImpactConcerns'
import { cloudhelpGet } from 'Utilities/CloudHelp'
import CustomerContract from './CustomerContracts'

class TicketAssets extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      client: {}
    }
  }

  componentDidMount () {
    this.getClient()
  }

  getClient = () => {
    const { ticket: { client_id } } = this.props
    if (_.isNil(client_id)) { return }

    cloudhelpGet(`/api/clients/${client_id}`)
      .then((response) => {
        this.setState({ client: response.data })
      })
  }

  render () {
    const { hidden, customerContracts } = this.props
    const { client } = this.state
    const columns = [
      { text: 'ID', accessor: 'id' },
      { text: 'Name', accessor: 'name' },
      { text: 'Family', accessor: 'family' },
      { text: 'Quantity', accessor: 'quantity' },
      { text: 'Datacentre', accessor: 'datacentre' },
      { text: 'Statement of Works', accessor: 'sow' }
    ]

    if (hidden) {
      return null
    }

    return (
      <>
        <ImpactConcerns {...this.props} />
        { client.services && (
          <Card padding="none">
            <ContentSectionBlock title="Clients services">
              <Table columns={columns} data={client.services} />
            </ContentSectionBlock>
          </Card>
        ) }

        {map(customerContracts, contract => (
          <ContentSection card>
            <React.Fragment>
              <ContentSectionBlock title={contract.name} style={{ paddingBottom: '0px' }} />
              <CustomerContract {...contract} />
            </React.Fragment>
          </ContentSection>
        ))}
      </>
    )
  }
}

export default TicketAssets
